import { FitMode } from 'shared/interfaces/planogram';
import { Vector2 } from 'three';
export function fitClusterChild(childSize, cellSize, fitMode) {
    switch (fitMode) {
        case FitMode.Fit: {
            const scaleFactor = cellSize.clone().divide(childSize);
            const minScaleFactor = Math.min(...scaleFactor.toArray().map(it => Math.abs(it)));
            return { scale: childSize.multiplyScalar(minScaleFactor) };
        }
        case FitMode.Fill: {
            const childRatio = childSize.clone().divide(cellSize);
            const cropRatio = new Vector2(1, 1)
                .multiplyScalar(Math.min(...childRatio.toArray()))
                .divide(childRatio);
            const cropOffset = new Vector2(1, 1).sub(cropRatio).multiplyScalar(0.5);
            return { scale: cellSize, cropOffset, cropRatio };
        }
        case FitMode.Stretch: {
            return { scale: cellSize };
        }
        default:
            throw new Error('Unknown fit type');
    }
}
